import React, { useState } from "react";
import PropTypes from "prop-types";
import { Field, Control, Label } from "rbx";
import FilterButtons from "../../../components/FilterButtons";
import { BooleanInput } from "../../../components/inputs";

const INITIAL_FILTER_STATE = {
  Status: true
};

const DrugTestCategoryFilters = ({ filters, onFilter, onClose }) => {
  const [inputs, setInputs] = useState({ ...filters });

  const handleChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setInputs({
      ...inputs,
      [e.target.name]: value
    });
  };

  const handleClose = () => onClose(onFilter(inputs));
  const handleCancel = () => onClose(onFilter(filters));
  const handleReset = () => onClose(onFilter({ ...INITIAL_FILTER_STATE }));

  return (
    <React.Fragment>
      <Field kind="group">
        <Control>
          <Label>Drug Test</Label>
          <BooleanInput
            name="DrugTest"
            value={inputs.DrugTest}
            onChange={handleChange}
          />
        </Control>
        <Control>
          <Label>Alcohol Test</Label>
          <BooleanInput
            name="AlcoholTest"
            value={inputs.AlcoholTest}
            onChange={handleChange}
          />
        </Control>
        <Control>
          <Label>Status</Label>
          <BooleanInput
            name="Status"
            value={inputs.Status}
            onChange={handleChange}
          />
        </Control>
      </Field>
      <hr />
      <FilterButtons
        handleCancel={handleCancel}
        handleClose={handleClose}
        handleReset={handleReset}
      />
    </React.Fragment>
  );
};

DrugTestCategoryFilters.propTypes = {
  filters: PropTypes.object,
  onFilter: PropTypes.func,
  onClose: PropTypes.func
};

export default DrugTestCategoryFilters;
